import { useTranslation } from 'react-i18next';

export default function PostSubmitGuide() {
  const { t } = useTranslation();
  const steps = [
    { numKey: 'apply.post.step1.num', titleKey: 'apply.post.step1.title', descKey: 'apply.post.step1.desc' },
    { numKey: 'apply.post.step2.num', titleKey: 'apply.post.step2.title', descKey: 'apply.post.step2.desc' },
    { numKey: 'apply.post.step3.num', titleKey: 'apply.post.step3.title', descKey: 'apply.post.step3.desc' },
  ];
  return (
    <section className="relative py-20 md:py-28 bg-background-100/40">
      <div className="max-w-[800px] mx-auto px-8">
        <div className="text-center mb-10">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            {t('apply.post.label')}
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('apply.post.title')}
          </h2>
          <p className="text-accent-500 text-[15px] tracking-[0.12em] mb-4 font-label">
            {t('apply.post.titleEn')}
          </p>
          <div className="gold-line mx-auto mb-6"></div>
          <p className="text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto">
            {t('apply.post.lead')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {steps.map((step) => (
            <div key={step.numKey} className="bg-background-50 border border-background-200/60 p-6 text-center">
              <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3 rounded-full border border-accent-500/30 bg-accent-500/[0.04]">
                <span className="font-heading text-accent-500 text-sm">{t(step.numKey)}</span>
              </div>
              <h3 className="text-[15px] text-foreground-800 tracking-[0.05em] font-medium mb-2">
                {t(step.titleKey)}
              </h3>
              <p className="text-[14px] text-foreground-500 tracking-[0.03em] leading-relaxed">
                {t(step.descKey)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
